import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	data: null,
};

const modelSlice = createSlice({
	name: 'model',
	initialState,
	reducers: {
		setModels(state, action) {
			state.data = action.payload;
		},
	},
});

export const { setModels } = modelSlice.actions;

export default modelSlice.reducer;
